export default __webpack_public_path__ + "static/media/Nihilistic Gloves.00f2e593.jpg";